const all = {
  label: '全部',
  value: 0,
};

const all2 = {
  label: '全部',
  value: -1,
};

export const invoiceTypes = [
  {
    label: '增值税专用发票（纸质）',
    value: 1,
  },
  {
    label: '增值税专用发票（电子）',
    value: 2,
  },
  {
    label: '增值税普通发票（纸质）',
    value: 3,
  },
  {
    label: '增值税普通发票（电子）',
    value: 4,
  },
];

export const invoiceTypesAll = [all].concat(invoiceTypes);

export const applyStatus = [
  {
    label: '待审核',
    value: 1,
  },
  {
    label: '开票中',
    value: 2,
  },
  {
    label: '已开票',
    value: 3,
  },
  {
    label: '已驳回',
    value: 4,
  },
];

export const applyStatusAll = [all].concat(applyStatus);

export const classStatusAll = [
  {
    label: '全部',
    value: -1,
  },
  {
    label: '停用',
    value: 0,
  },
  {
    label: '启用',
    value: 1,
  },
];

export const auditStatusAll = [
  {
    label: '同意',
    value: 1,
  },
  {
    label: '拒绝',
    value: 0,
  },
];

export const taxStatusEnum = [
  {
    label: '全部',
    value: -1,
  },
  {
    label: '待上传',
    value: 0,
  },

  {
    label: '已上传',
    value: 1,
  },

  {
    label: '已驳回',
    value: 2,
  },

  {
    label: '已更新',
    value: 3,
  },
];

export const contractStatusEnum = [
  {
    label: '未生效',
    value: 0,
  },
  {
    label: '已生效',
    value: 1,
  },
  {
    label: '过期失效',
    value: 2,
  },
  {
    label: '合同终止',
    value: 3,
  },
];

export const contractStatusAll = [all2].concat(contractStatusEnum);

export default {
  invoiceTypes,
};



// WEBPACK FOOTER //
// ./src/utils/enum.js